import { Link } from 'react-router-dom';
import { ArrowRight, FileText, Shield } from 'lucide-react';
import { Button } from '../ui/button';

function scrollToPlans(event) {
  event.preventDefault();
  const target = document.getElementById('planos');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export function CTA({ copy }) {
  return (
    <section className="overflow-hidden rounded-[36px] bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-900 px-6 py-10 shadow-xl shadow-slate-900/15 sm:px-8 lg:px-12 lg:py-14">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-200">
            {copy.eyebrow}
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {copy.title}
          </h2>
          <p className="mt-4 text-base leading-7 text-blue-100">
            {copy.description}
          </p>

          <div className="mt-6 flex flex-wrap gap-3 text-sm text-blue-100">
            <Link to="/pages/termos-de-uso"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 transition hover:bg-white/15">
              <FileText className="h-4 w-4" />
              {copy.termsLink}
            </Link>
            <Link to="/pages/politica-de-privacidade" 
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 transition hover:bg-white/15">
              <Shield className="h-4 w-4" />
              {copy.privacyLink}
            </Link>
          </div>
        </div>

        <Button asChild size="lg" className="bg-white text-blue-700 hover:bg-blue-50">
          <a href="#planos" onClick={scrollToPlans}>
            {copy.button}
            <ArrowRight className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </section>
  );
}
